const SET_HOVER_BOX = 'setHoverBox';
const CLEAR_HOVER_BOX = 'clearHoverBox';

export { SET_HOVER_BOX, CLEAR_HOVER_BOX };
